/**
 * StatusBadge Component - TASK-178 (migrated to the TASK-661 semantic system)
 *
 * Displays prospect/client lifecycle status via the shared ui/StatusBadge:
 * prospect = attention (not yet fully onboarded), client = verified success.
 * Public API unchanged for all existing call sites.
 *
 * Usage:
 *   <StatusBadge status="prospect" size="md" />
 *   <StatusBadge status="client" size="sm" showIcon={false} />
 */

import React from 'react';
import { StatusBadge as SemanticBadge } from '../ui/status-badge';

interface StatusBadgeProps {
  status: string;
  size?: 'sm' | 'md' | 'lg';
  showIcon?: boolean;
  className?: string;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  size = 'md',
  showIcon = true,
  className = '',
}) => {
  const isProspect = status === 'prospect';

  const tooltipText = isProspect
    ? 'Prospect - Not yet fully onboarded. Limited actions until KYC is approved.'
    : 'Client - Fully onboarded with complete access';

  return (
    <SemanticBadge
      status={isProspect ? 'attention' : 'success'}
      size={size === 'sm' ? 'sm' : 'md'}
      icon={showIcon ? undefined : null}
      title={tooltipText}
      aria-label={tooltipText}
      className={`font-semibold uppercase tracking-wide ${className}`}
    >
      {isProspect ? 'Prospect' : 'Client'}
    </SemanticBadge>
  );
};

export default StatusBadge;
